import { useEffect, useRef, useState } from "react";

import "./slider_of_ages.scss";
import { observer } from "mobx-react-lite";
import generalStore from "../../stores/general_store/general_store";

function SliderOfAges() {
	const [ageWidth, setAgeWidth] = useState<number>(0);

	const ageRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (ageRef.current) setAgeWidth(ageRef.current.offsetWidth);
		scrollToAge(generalStore.currentAge);
	}, [generalStore.currentAge]);

	const agesWrapperRef = useRef<HTMLDivElement>(null);
	const getAgePosition = (age: number) => {
		if (!ageWidth || !agesWrapperRef.current) return;
		if (!generalStore.ages.includes(age)) return;
		return ageWidth * generalStore.ages.indexOf(age) * 1.02;
	};
	const scrollToAge = (age: number) => {
		if (!agesWrapperRef.current) return;
		agesWrapperRef.current.scrollTo({
			left: getAgePosition(age),
		});
		if (generalStore.currentAge !== age) {
			generalStore.currentAge = age;
			generalStore.requiredUpdateCurrentAge = true;
		}
	};

	const getAgeByPosition = (position: number) => {
		if (!ageWidth || !agesWrapperRef.current) return;
		let currentAgeIndex = 0;
		let currentPosition = position;
		for (let i = 0; i < generalStore.ages.length; i++) {
			currentPosition -= ageWidth;
			if (currentPosition <= 0) {
				currentAgeIndex = i;
				break;
			}
		}
		return generalStore.ages[currentAgeIndex];
	};

	const [scrollToAgeTimeout, changeScrollToAgeTimeout] = useState<
		NodeJS.Timeout | undefined
	>();
	const [stopScrollTimeout, changeStopScrollTimeout] = useState<
		NodeJS.Timeout | undefined
	>();
	const agesScrollHandler = (e: any) => {
		if (stopScrollTimeout) clearTimeout(stopScrollTimeout);
		changeStopScrollTimeout(
			setTimeout(() => {
				if (e.target) {
					const age = getAgeByPosition(
						e.target.scrollLeft + ageWidth / 3
					);
					console.log(age);
					if (age) scrollToAge(age);
				}
				let NewScrollTimeout = setTimeout(() => {}, 200);
				clearTimeout(scrollToAgeTimeout);
				changeScrollToAgeTimeout(NewScrollTimeout);
			}, 500)
		);
	};

	return (
		<>
			<div
				className="ages_wrapper"
				ref={agesWrapperRef}
				onScroll={agesScrollHandler}
			>
				<div className="spacer"></div>
				{generalStore.ages.map((age, index) => (
					<div className="age_wrapper" key={index} ref={ageRef}>
						<span
							className={
								"age " +
								(generalStore.currentAge === age
									? "active"
									: "")
							}
							onClick={() => {
								scrollToAge(age);
							}}
						>
							{age}-е
						</span>
					</div>
				))}
				<div className="spacer"></div>
			</div>
			<div className="arrow_wrapper">
				<div className="arrow"></div>
			</div>
		</>
	);
}

export default observer(SliderOfAges);
